import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class VideosComponent implements OnInit {
  @Input() public videoUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ViewChild('videoPlayer') public videoplayer: any;
  @Input() public width: number;
  @Input() public autoPlay: boolean = false;
  @Input() public height: number;
  @Input()
  private set videoClosed(value: boolean) {
    if (this.videoplayer) {
      this.videoplayer.nativeElement.pause();
    }
  }
  @Input() public isVideoControls: boolean;
  @Output() public videoClicked = new EventEmitter();

  public ngOnInit(): void {
    if (this.autoPlay && this.videoplayer) {
      this.videoplayer.nativeElement.play();
    }
  }
  public playVideo(videoUrl: string): void {
    this.videoClicked.emit(videoUrl);
  }
}
